<template>
  <div class="youtaofang">
    <topTitle title="钱湖柏庭" :list="list" :newData="newData"></topTitle>
    <div class="content">
      <div class="item" v-for="(item, index) in list2[number].list" :key="index">
        <img :src="item.img" alt="" />
      </div>
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "居",
          small_title: "HOUSE",
          hasTitle: "柏庭相册",
        },
        {
          title: "学",
          small_title: "LEARN",
          hasTitle: "柏庭相册",
        },
        {
          title: "食",
          small_title: " FOOD",
          hasTitle: "柏庭相册",
        },
        {
          title: "乐",
          small_title: "HAPPY",
          hasTitle: "柏庭相册",
        },
      ],
      newData: 1,
      list2: [
        {
            //居
          list: [
            {
              img: require("../../assets/image/live/1.png"),
            },
            {
              img: require("../../assets/image/live/2.png"),
            },
            {
              img: require("../../assets/image/live/3.png"),
            },
            {
              img: require("../../assets/image/live/4.png"),
            },
            {
              img: require("../../assets/image/live/5.png"),
            },
            {
              img: require("../../assets/image/live/6.png"),
            },
            {
              img: require("../../assets/image/live/7.png"),
            },
            {
              img: require("../../assets/image/live/8.png"),
            },
          ],
        },
        {
            //学
          list: [
            {
              img: require("../../assets/image/study/1.png"),
            },
            {
              img: require("../../assets/image/study/2.png"),
            },
            {
              img: require("../../assets/image/study/3.png"),
            },
            {
              img: require("../../assets/image/study/4.png"),
            },
            {
              img: require("../../assets/image/study/5.png"),
            },
            {
              img: require("../../assets/image/study/6.png"),
            },
            
          ],
        },
        {
            //食
          list: [
            {
              img: require("../../assets/image/food/1.png"),
            },
            {
              img: require("../../assets/image/food/2.png"),
            },
            {
              img: require("../../assets/image/food/3.png"),
            },
            {
              img: require("../../assets/image/food/4.png"),
            },
            {
              img: require("../../assets/image/food/5.png"),
            },
            {
              img: require("../../assets/image/food/6.png"),
            },
            {
              img: require("../../assets/image/food/7.png"),
            },
            {
              img: require("../../assets/image/food/8.png"),
            },
          ],
        },
        {
            //乐
          list: [
            {
              img: require("../../assets/image/happy/1.png"),
            },
            {
              img: require("../../assets/image/happy/2.png"),
            },
            {
              img: require("../../assets/image/happy/3.png"),
            },
            {
              img: require("../../assets/image/happy/4.png"),
            },
            {
              img: require("../../assets/image/happy/5.png"),
            },
            {
              img: require("../../assets/image/happy/6.png"),
            },
            {
              img: require("../../assets/image/happy/7.png"),
            },
            {
              img: require("../../assets/image/happy/8.png"),
            },
          ],
        },
        
      ],
      number:0
    };
  },
  created: function () {
    this.number = this.$route.query.majorName;
     this.newData= parseInt(this.$route.query.majorName);
  },
  methods: {},
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {},
};
</script>
<style scoped="scoped">
.youtaofang {
  width: 100%;
  height: 100%;
}
.content {
  padding: 0.7375rem 0.5625rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.item {
  width: 5.25rem;
  height: 3.9375rem;
  border-radius: 10px;
  margin-bottom: 0.8rem;
  position: relative;
}
.item img {
  width: 5.25rem;
  /* height: 3.9375rem; */
  border-radius: 10px;
}
.item_show {
  position: absolute;
  width: 5.25rem;
  height: 3.9375rem;
  border-radius: 10px;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 0.7375rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.item_show div {
  width: 0.2375rem;
  height: 2px;
  background: #ffffff;
  margin: 0 0.225rem;
}
</style>